/* C&T Tech — theme.js (no framework) */
(function () {
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* Guest price safety net — strip any price node injected by apps/widgets */
  if (window.__customerLoggedIn === false) {
    const PRICE_SELECTORS = '.price,.money,[data-price],.product-price,.pdp__price,.product__price,.price-item,.price__regular,.price__sale,[class*="price"]:not(.price-locked):not(.price-locked-panel)';
    const scrub = (root) => {
      root.querySelectorAll(PRICE_SELECTORS).forEach((el) => {
        if (el.closest('.price-locked-panel') || el.classList.contains('price-locked')) return;
        if (/[£$€¥]|\d+\.\d{2}/.test(el.textContent || '')) el.remove();
      });
    };
    const main = document.getElementById('MainContent') || document.body;
    const run = () => scrub(main);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    new MutationObserver(() => scrub(main)).observe(main, { childList: true, subtree: true });
  }

  /* Mobile menu */
  const menu = $('[data-mobile-menu]');
  $$('[data-menu-open]').forEach((b) => b.addEventListener('click', () => menu && menu.setAttribute('aria-hidden', 'false')));
  $$('[data-menu-close]').forEach((b) => b.addEventListener('click', () => menu && menu.setAttribute('aria-hidden', 'true')));
  menu && menu.addEventListener('click', (e) => { if (e.target === menu) menu.setAttribute('aria-hidden', 'true'); });

  /* Cart drawer */
  const drawer = $('[data-cart-drawer]');
  const openDrawer = () => drawer && drawer.setAttribute('aria-hidden', 'false');
  const closeDrawer = () => drawer && drawer.setAttribute('aria-hidden', 'true');
  $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); refreshCart().then(openDrawer); }));
  $$('[data-cart-close]').forEach((b) => b.addEventListener('click', closeDrawer));
  drawer && drawer.querySelector('.cart-drawer__overlay')?.addEventListener('click', closeDrawer);

  function money(cents) {
    if (window.Shopify && window.Shopify.formatMoney) return Shopify.formatMoney(cents, window.theme_money_format || '£{{amount}}');
    return '£' + (cents / 100).toFixed(2);
  }

  function renderCart(cart) {
    const countEls = $$('[data-cart-count]');
    countEls.forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    const list = $('[data-cart-items]');
    if (!list) return;
    if (!cart.items.length) {
      list.innerHTML = '<p class="text-muted" style="padding:1rem 0;">Your cart is empty.</p>';
    } else {
      list.innerHTML = cart.items.map((i) => `
        <div class="cart-drawer__item">
          <img src="${i.image || ''}" alt="">
          <div>
            <div style="font-weight:600;font-size:.9rem;">${i.product_title}</div>
            ${i.variant_title ? `<div class="text-muted" style="font-size:.8rem;">${i.variant_title}</div>` : ''}
            <div class="text-muted" style="font-size:.8rem;">Qty ${i.quantity}</div>
          </div>
          <div style="text-align:right;">
            <div style="font-weight:600;">${money(i.final_line_price)}</div>
            <button class="btn btn--ghost" style="padding:.2rem .4rem;font-size:.75rem;" data-cart-remove="${i.key}">Remove</button>
          </div>
        </div>`).join('');
    }
    const total = $('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);
    $$('[data-cart-remove]').forEach((b) => b.addEventListener('click', () => updateLine(b.dataset.cartRemove, 0)));
  }

  async function refreshCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await res.json();
    renderCart(cart);
    return cart;
  }

  async function updateLine(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    const cart = await res.json();
    renderCart(cart);
  }

  /* Ajax add-to-cart */
  $$('form[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type=submit]');
      const original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      const fd = new FormData(form);
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error((await res.json()).description || 'Could not add to cart');
        await refreshCart();
        openDrawer();
      } catch (err) {
        alert(err.message);
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = original; }
      }
    });
  });

  /* Quantity stepper */
  $$('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelector('[data-qty-dec]')?.addEventListener('click', () => { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    wrap.querySelector('[data-qty-inc]')?.addEventListener('click', () => { input.value = (parseInt(input.value, 10) || 1) + 1; });
  });

  /* Gallery thumbnails */
  $$('[data-gallery]').forEach((g) => {
    const main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach((t) => {
      t.addEventListener('click', () => {
        if (!main) return;
        main.src = t.dataset.src || t.src;
        g.querySelectorAll('[data-gallery-thumb]').forEach((x) => x.classList.remove('is-active'));
        t.classList.add('is-active');
      });
    });
  });

  /* Refresh cart count on load */
  if ($('[data-cart-count]')) refreshCart();
})();
